<template>
  <v-flex x12>
    <h2 class="nx-heading--level-1" v-text="title"/>
    <nx-taxonomy-selector
      :value="value"
      @input="onInput"
      :limit="1"
      :label="$t('message.permissions.filters.taxonomySelector')"
    />
  </v-flex>
</template>

<script>
import NxTaxonomySelector from '@/modules/taxonomy/selector/Selector';

export default {
  name: 'dashboard-shortcut-wizard-taxonomy-access-action',
  components: {
    NxTaxonomySelector,
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    title() {
      return this.$t('message.dashboard.shortcuts.wizard.title.filterResourceEntity', {
        resource: this.$tc('message.dashboard.shortcuts.resource.taxonomy'),
      });
    },
  },
  methods: {
    onInput(taxonomy) {
      this.value = taxonomy;
      if (!taxonomy) {
        this.$emit('input', null);
      }

      const url = this.$router.resolve({
        name: 'entity.editor',
        params: {
          entity: taxonomy.type,
          id: taxonomy.id,
        },
      });

      this.$emit('input', {
        type: taxonomy.type,
        url: url.href,
        text: taxonomy.name,
      });
    },
  },
};
</script>
